import { AddressModel } from '../services/address/model/address.model';

export const getResidenceInfo = (selectedAddress: AddressModel) => {
  const unitName = selectedAddress.subBuildingName || selectedAddress.departmentName || null;

  const buildingName =
    selectedAddress.buildingName ||
    selectedAddress.organisationName ||
    (selectedAddress.poBox ? `PO Box ${selectedAddress.poBox}` : null) ||
    null;

  const items = [unitName, buildingName].filter(Boolean);
  return items.length ? items.join(', ') : null;
};

export const getStreetInfo = (selectedAddress: AddressModel) => {
  const { buildingNumber, dependantThoroughfare, streetName } = selectedAddress;

  const street =
    dependantThoroughfare && streetName
      ? `${dependantThoroughfare} ${streetName}`
      : streetName || dependantThoroughfare || null;

  const items = [buildingNumber, street].filter(Boolean);
  return items.length ? items.join(' ') : null;
};

export const getAddressLine1 = (address: AddressModel) => {
  const residenceInfo = getResidenceInfo(address);
  const streetInfo = getStreetInfo(address);

  const items = [residenceInfo, streetInfo].filter(Boolean);
  return items.length ? items.join(', ') : '';
};
